const chat = {
  namespaced: true,
  state: {
    chatMesList: []
  },
  mutations: {
    'MODIFY_CHAT_MESLIST'(state, payload: any[]) {
      state.chatMesList = payload
    }
  },
  actions: {
    nodifyChatMesList(context, list: any[]) {
      console.log('ssss')
      console.log(list)
      context.commit('MODIFY_CHAT_MESLIST', list)
    }
  }
}
export default chat
